import React, { useState } from 'react';
import PropTypes from "prop-types";

export default function CsfFournisseurRecognitionRenewalTitle({ formData, isRenewal }) {

  const currentLanguage = document.querySelector('html').getAttribute('lang');

  return (
    <>
    {isRenewal && (
      <h2 className="renewal-title">
        {/* 0 = fr, 1 = en, 2 = bilingue */}
        {/* In some cases, Language_ datatype not as expected */}
        {formData.Language_ === '0' || formData.Language_ === 0 ? (<>
          {formData.Name_French}
        </>) : null}
        {formData.Language_ === '1' || formData.Language_ === 1 ? (<>
          {formData.Name_English}
        </>) : null}
        {formData.Language_ === '2' || formData.Language_ === 2 ? (<>
          {currentLanguage === 'en' ? (
            <>
              {formData.Name_English}
            </>
          ) : (
            <>
              {formData.Name_French}
            </>
          )}
        </>) : null}
        {formData.Recognition_Code && (<>
          &nbsp;- #{formData.Recognition_Code}
        </>)}
      </h2>
    )}
    </>
  );
}

CsfFournisseurRecognitionRenewalTitle.propTypes = {
  formData: PropTypes.object,
  isRenewal: PropTypes.bool
};
